'use strict';

import {observable, configure, action, makeObservable, flow} from "mobx";
configure({enforceActions: 'always'});

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';

import api from '../lib/Api';
import RegToolsInjector from "../common/RegToolsInjector";

const analyticsStore = appStore.getAnalyticsStore();

class AcknowledgementsStore {
    state = States.initial;

    exceptionUtils = appStore.getExceptionUtils();

    formData = {
        // acknowledgements we're going to update
        acknowledgedNew: {}
    }

    showModal = false;

    onSuccess = () => {};

    mockData = {
        "acknowledged": {
            "meningo": true,
            "voter": true,
            "riaa": true,
            "clery": true,
            "upass": true,
            "finliab": true,
            "ferpa": true
        }
    }

    constructor() {
        makeObservable(this, {
            state: observable,
            formData: observable,
            showModal: observable,
            updateAcknowledgement: action,
            mount: action,
            openModal: action,
            closeModal: action
        })
    }

    mount = flow(function* (onSuccess) {
        if (appStore.isStudent()) {
            this.state = States.pending;
            this.onSuccess = onSuccess;
            try {
                let params = null
                if (RegToolsInjector.isPreProdEnvironment()) {
                    params = RegToolsInjector.generateAcknowledgeParams();
                }
                this.formData = {...yield api.getAcknowledgements(params), ...this.formData};
                this.state = States.done;
            } catch (e) {
                this.exceptionUtils.handleException(e);
                this.state = States.error;
            }
        } else {
            this.state = States.done;
        }
    }.bind(this));

    openModal = () => {
        analyticsStore.addEvent("RegPrev-AcknowledgementsOpened",{}, {});
        this.showModal = true;
    }
    closeModal = () => {
        analyticsStore.addEvent("RegPrev-AcknowledgementsClosed",{}, {});
        this.resetFormData();
        this.showModal = false;
    }

    updateAcknowledgement = (name, value, fromPreReg = false) => {
        if (fromPreReg) {
            this.formData.acknowledgedNew[name] = value;
        } else {
            this.state = States.pending;
            this.formData.acknowledgedNew[name] = value;
            // if all the required acknowledgements are acknowledged
            if (this.areAcknowledgementsDone()) {
                this.saveAcknowledgements();
            } else {
                this.state = States.done;
            }
        }
    }

    areAcknowledgementsDone = () => {
        if (this.formData.hasOwnProperty("acknowledged") && this.formData.hasOwnProperty("acknowledgedNew")) {
            // for all false acknowledged props, the formData.acknowledgedNew should contain true props to match
            let requiredAcknowledgements = Object.entries(this.formData.acknowledged).filter(([key, value]) => value === false).map(item => item[0]);
            // list of all true acknowledgedNew
            let acknowledgedNew = Object.entries(this.formData.acknowledgedNew).filter(([key, value]) => value).map(item => item[0]);
            return requiredAcknowledgements.every(ack => acknowledgedNew.includes(ack));
        } else {
            return false;
        }
    }

    saveAcknowledgements = flow(function* (fromUpdate = true) {
        if (!fromUpdate) {this.state = States.pending;}
        try {
            let additionalData = this.formData?.acknowledgedNew ?? {};
            this.formData = yield api.updateAcknowledgements(this.formData.acknowledgedNew);
            this.state = States.done;
            this.closeModal();
            this.onSuccess();
            analyticsStore.addEvent("RegPrev-AcknowledgementsSaved",{}, {
                acknowledged: Object.keys(additionalData).join(','),
                count: Object.keys(additionalData).length
            });
        } catch (e) {
            this.exceptionUtils.handleException(e);
            this.state = States.error;
        }
    }.bind(this));

    getCampus = () => {
        return this.formData.campus;
    }

    resetFormData = () => {
        this.formData.acknowledgedNew = {}
    }

    getNewAcknowledgementValue = (name) => {
        return this.formData.acknowledgedNew[name];
    }
}

export default new AcknowledgementsStore();